interface ChartOptionsParams {
    showToolbar: boolean;
    dateType: string;
    chartTitle?: string;
    yAxisTitle?: string;
    labelFormatterDecimals?: number;
    tooltipOptions?: { shared?: boolean; intersect?: boolean };
    theme?: string;
}

export const getDefaultChartOptions = ({
    showToolbar,
    dateType,
    chartTitle = "",
    yAxisTitle = "No Title",
    labelFormatterDecimals = 2,
    tooltipOptions = { shared: true, intersect: false },
}: ChartOptionsParams) => ({
    title: {
        text: chartTitle,
        align: 'center',
        margin: 5,
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize:  '12px',
          fontWeight:  'bold',
          color: getComputedStyle(document.documentElement).getPropertyValue('--text').trim(),
        },
    },
    chart: {
        borderRadius: 100,
        responsive: true,
        zoom: {
            enabled: true,
            allowMouseWheelZoom: false,
        },
        toolbar: {
            show: showToolbar,
        },
    },
    noData: {
        text: "No data available",
        align: "center",
        offsetX: 0,
        offsetY: 0,
        style: {
            fontSize: "14px",
        },
    },
    legend: {
        position: "top",
    },
    xaxis: {
        type: "category",
        title: {
            text: dateType === "day" ? "Hour of Day" : "Date",
        },
    },
    yaxis: {
        title: {
            text: yAxisTitle,
        },
        labels: {
            formatter: (value: any) => value.toFixed(labelFormatterDecimals),
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        width: [2, 2, 2, 2],
    },
    tooltip: {
        shared: true,
        intersect: false,
        ...tooltipOptions,
    }
});